import React from 'react'
import Select from 'react-select';
import PropTypes from 'prop-types';
import './version-selector.scss'


const customStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: 'calc(100vh - 180px)',
    minHeight: '200px',
    paddingTop: '8px'
  }),
  groupHeading: (provided) => ({
    ...provided,
    color: 'var(--color-text)'
  })
}

function VersionSelector({ 
  selectedOption = {},
  handleChange, 
  options = [],
  display = null
}){

  const updatedSelectedOption = {
    ...selectedOption,
    label: selectedOption.value
  }

  return (
    <div className={`versionSelector ${display}`} title="Select product">
      <Select
        value={updatedSelectedOption}
        onChange={(newProd) => handleChange(newProd)}
        options={options} 
        classNamePrefix="react-select"
        isSearchable={false}
        // menuIsOpen
        styles={customStyles}
        aria-label="product selector"
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'transparent',
            primary: '#093e73'
          }
        })}
      />
    </div>
  )
}


VersionSelector.propTypes = {
  selectedOption: PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }),
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  display: PropTypes.string
}

export default VersionSelector
